<template>
    <div id="edit"  class="jc-page jc-checklisttemp-page">
        <div class="jc-panel jc-page-head">
			<div class="header-title">
                <span><i class="el-icon-arrow-left" @click="returnPage"></i></span>
                <span class="header-title">{{currentObject.checkup_subject_name}}</span>
            </div>
			<div class="header-operation">
				<el-form ref="form" :model="form">
                    <el-button class="button" @click="cancel">取消</el-button>
                    <el-button class="button" @click="save">确定</el-button>
                </el-form>
			</div>
		</div>
        <div class="jc-table-container jc-scroll-panel">
            <div class="main-top">
                <h5 class="baseInfo">基础信息</h5>
                <div class="baseInfo-select">
                    <el-form :model="form" ref="form">
                        <el-form-item label="检查表名称">
                            <el-input v-model="form.name" placeholder="请输入检查表名称"></el-input>
                        </el-form-item>
                        <el-form-item label="机构类型">
                            <el-select clearable disabled v-model="form.organType" placeholder="请选择机构类型" @change="handleChange()">
                                <el-option
                                    v-for="item in organOptions"
                                    :key="item.organization_type_id"
                                    :label="item.organization_type_name"
                                    :value="item.organization_type_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="考察层级">
                            <el-cascader clearable
                                style="width:210px;height:30px;"
                                v-model="form.level"
                                :options="levelOptions"
                                :props="{ multiple: true, checkStrictly: true,value:'investigation_level_id',label:'investigation_level_name'}"
                                placeholder="请选择考察层级">
                            </el-cascader>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="main-checkentry">
                <div class="checkentry-top">
                    <div class="checkentry-left">
                        <span>安全检查条目库</span>
                    </div>
                    <div class="checkentry-right">
                        <el-input v-model="keyWord" placeholder="关键字查询"></el-input>
                        <el-input v-model="entryId" placeholder="检查条目编号"></el-input>
                        <el-cascader clearable
                            :options="classlistTree"
                            props.checkStrictly = true
                            :props="classlistTreeProps"
                            v-model="type"
                            placeholder="归属检查分类"
                            :show-all-levels="false"></el-cascader>
                        <el-button class="button" @click="getCheckObject">查询</el-button>
                        <el-button class="button" @click="addCheckTableMutli">添加</el-button>
                    </div>
                </div>
                <el-table
                height="500px" stripe border
                ref="multipleTable"
                :data="allCheckObj"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleEntrySelectionChange">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <!-- <el-table-column type="index" label="序号" width="55"></el-table-column> -->
                        <el-table-column label="检查编号" prop="checkup_item_no" width="80" :sortable="true" :sort-orders="['ascending', 'descending', null]">
                            <template slot-scope="scope">{{scope.row.checkup_item_no}}</template>
                        </el-table-column>
                        <el-table-column label="类别" width="100">
                            <template slot-scope="scope">{{scope.row.checkup_category_name}}</template>
                        </el-table-column>
                        <el-table-column label="项目" width="150">
                            <template slot-scope="scope">{{scope.row.checkup_item_name}}</template>
                        </el-table-column>
                        <el-table-column label="评估内容" width="200">
                            <template slot-scope="scope">{{scope.row.checkup_item_evaluation_content}}</template>
                        </el-table-column>
                        <el-table-column label="标准分" width="70">
                            <template slot-scope="scope">{{scope.row.checkup_item_basic_score}}</template>
                        </el-table-column>
                        <el-table-column label="评分标准" width="200">
                            <template slot-scope="scope">{{scope.row.checkup_item_score_point}}</template>
                        </el-table-column>
                        <el-table-column label="评估方式" width="100">
                            <template slot-scope="scope">
                                <div class="evaluation" v-for="(item,index) in scope.row.checkup_item_evaluation_origin_list" :key="index">{{item.evaluation_method_type_name}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="检查要点/支撑材料">
                            <template slot-scope="scope">
                                <div class="material" v-for="(item,index) in scope.row.checkup_item_evaluation_origin_list" :key="index">{{item.checkup_item_inspection_point}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="标准化要求" min-width="200">
                            <template slot-scope="scope">{{ scope.row.checkup_item_standard_require }}</template>
                          </el-table-column>

                          <el-table-column label="企业达标标准" min-width="200">
                            <template slot-scope="scope">{{ scope.row.checkup_item_standard_point }}</template>
                          </el-table-column>

                          <el-table-column label="评审方法" min-width="200">
                            <template slot-scope="scope">{{ scope.row.checkup_item_review_method }}</template>
                          </el-table-column>

                          <el-table-column label="评审标准-否却项" min-width="200">
                            <template slot-scope="scope">{{ scope.row.checkup_item_review_criteria_no_but }}</template>
                          </el-table-column>

                          <el-table-column label="评审标准-扣分项" min-width="200">
                            <template slot-scope="scope">{{ scope.row.checkup_item_review_criteria_deduction }}</template>
                          </el-table-column>

                          <el-table-column label="标准化评审规范号" min-width="200">
                            <template slot-scope="scope">{{ scope.row.checkup_item_standard_review_number }}</template>
                          </el-table-column>

                          <el-table-column label="标准化评审内容" min-width="200">
                            <template slot-scope="scope">{{ scope.row.checkup_item_standard_review_content }}</template>
                          </el-table-column>

                          <el-table-column label="检查内容" min-width="200">
                            <template slot-scope="scope">{{ scope.row.checkup_item_inspection_content }}</template>
                          </el-table-column>

                          <el-table-column label="检查依据" min-width="200">
                            <template slot-scope="scope">{{ scope.row.checkup_item_inspection_basis }}</template>
                          </el-table-column>

                          <el-table-column label="检查方法" min-width="200">
                            <template slot-scope="scope">{{ scope.row.checkup_item_inspection_method }}</template>
                          </el-table-column>

                          <el-table-column label="案例照片" min-width="200">
                            <template slot-scope="scope">
                              <template v-if="scope.row.checkup_item_case_image_list.length > 0">
                              <span v-for="(item, index) in scope.row.checkup_item_case_image_list" :key="index">
                                <img class="qua-img" :src="item.source" :preview='scope.row.checkup_item_id'>
                              </span>
                            </template>
                              <span v-else>--</span>
                            </template>
                          </el-table-column>

                          <el-table-column label="完成时限" min-width="200">
                            <template slot-scope="scope">{{ scope.row.checkup_item_complete_time_limit }}</template>
                          </el-table-column>
                            <!-- <el-table-column label="属地部门" width="100">
                            <template slot-scope="scope">{{scope.row.checkup_department_name}}</template>
                        </el-table-column> -->
                        <el-table-column label="操作" width="100">
                                <template slot-scope="scope">
                                        <el-button @click="addCheckTable(scope.$index, scope.row)" type="text" size="small">添加</el-button>
                                </template>
                        </el-table-column>
                </el-table>
            </div>
            <!-- 检查表 -->
            <div class="main-checktable">
                <div class="checktable-top">
                    <div class="checktable-left">
                        <span>检查表</span>
                    </div>
                    <div class="checktable-right">
                        <el-button class="button" @click="handleMultEdit">编辑</el-button>
                        <el-button class="button" @click="deleteMutil">删除</el-button>
                    </div>
                </div>
                <el-table
                ref="multipleTableList"
                :data="checktableData"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleTableSelectionChange">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <!-- <el-table-column type="index" label="序号" width="55"></el-table-column> -->
                        <el-table-column label="检查编号" prop="checkup_item_no" width="80" :sortable="true" :sort-orders="['ascending', 'descending', null]">
                            <template slot-scope="scope">{{scope.row.checkup_item_no}}</template>
                        </el-table-column>
                        <el-table-column label="类别" width="100">
                            <template slot-scope="scope">{{scope.row.checkup_category_name}}</template>
                        </el-table-column>
                        <el-table-column label="项目" width="150">
                            <template slot-scope="scope">{{scope.row.checkup_item_name}}</template>
                        </el-table-column>
                        <el-table-column label="评估内容" width="200">
                            <template slot-scope="scope">{{scope.row.checkup_item_evaluation_content}}</template>
                        </el-table-column>
                        <el-table-column label="标准分" width="70">
                            <template slot-scope="scope">{{scope.row.checkup_item_basic_score}}</template>
                        </el-table-column>
                        <el-table-column label="评分标准" width="200">
                            <template slot-scope="scope">{{scope.row.checkup_item_score_point}}</template>
                        </el-table-column>
                        <el-table-column label="评估方式" width="100">
                            <template slot-scope="scope">
                                <div class="evaluation" v-for="(item,i) in scope.row.checkup_item_evaluation_origin_list " :key="i">
                                    {{item.evaluation_method_type_name}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="检查要点/支撑材料">
                            <template slot-scope="scope">
                                <div class="material" v-for="(item,i) in scope.row.checkup_item_evaluation_origin_list" :key="i">
                                    {{item.checkup_item_inspection_point}}
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column label="标准化要求" min-width="200">
                            <template slot-scope="scope">{{ scope.row.checkup_item_standard_require }}</template>
                          </el-table-column>

                          <el-table-column label="企业达标标准" min-width="200">
                            <template slot-scope="scope">{{ scope.row.checkup_item_standard_point }}</template>
                          </el-table-column>

                          <el-table-column label="评审方法" min-width="200">
                            <template slot-scope="scope">{{ scope.row.checkup_item_review_method }}</template>
                          </el-table-column>

                          <el-table-column label="评审标准-否却项" min-width="200">
                            <template slot-scope="scope">{{ scope.row.checkup_item_review_criteria_no_but }}</template>
                          </el-table-column>

                          <el-table-column label="评审标准-扣分项" min-width="200">
                            <template slot-scope="scope">{{ scope.row.checkup_item_review_criteria_deduction }}</template>
                          </el-table-column>

                          <el-table-column label="标准化评审规范号" min-width="200">
                            <template slot-scope="scope">{{ scope.row.checkup_item_standard_review_number }}</template>
                          </el-table-column>

                          <el-table-column label="标准化评审内容" min-width="200">
                            <template slot-scope="scope">{{ scope.row.checkup_item_standard_review_content }}</template>
                          </el-table-column>

                          <el-table-column label="检查内容" min-width="200">
                            <template slot-scope="scope">{{ scope.row.checkup_item_inspection_content }}</template>
                          </el-table-column>

                          <el-table-column label="检查依据" min-width="200">
                            <template slot-scope="scope">{{ scope.row.checkup_item_inspection_basis }}</template>
                          </el-table-column>

                          <el-table-column label="检查方法" min-width="200">
                            <template slot-scope="scope">{{ scope.row.checkup_item_inspection_method }}</template>
                          </el-table-column>

                          <el-table-column label="案例照片" min-width="200">
                            <template slot-scope="scope">
                              <template v-if="scope.row.checkup_item_case_image_list.length > 0">
                              <span v-for="(item, index) in scope.row.checkup_item_case_image_list" :key="index">
                                <img class="qua-img" :src="item.source" :preview='scope.row.checkup_item_id'>
                              </span>
                            </template>
                              <span v-else>--</span>
                            </template>
                          </el-table-column>

                          <el-table-column label="完成时限" min-width="200">
                            <template slot-scope="scope">{{ scope.row.checkup_item_complete_time_limit }}</template>
                          </el-table-column>
                        <el-table-column label="属地部门" width="100">
                            <template slot-scope="scope">{{scope.row.checkup_department_name}}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="100">
                                <template slot-scope="scope">
                                        <el-button @click="handleEdit(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
                                        <span>|</span>
                                        <el-button type="text" size="small" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                                </template>
                        </el-table-column>
                </el-table>
            </div>
        </div>
        <el-dialog title="编辑" :visible.sync="dialogVisible" class="dialog">
			<el-form ref="editForm" :model="editForm">
                <el-form-item label="属地部门">
                    <el-input v-model="editForm.department" placeholder="请输入属地部门"></el-input>
                </el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
					<el-button @click="cancelModify">取消</el-button>
					<el-button type="primary" @click="departmentSubmit()">确定</el-button>
			</div>
		</el-dialog>
    </div>
</template>
<script>
import { Container } from 'element-ui';
import {eventBus} from '../../../../../eventbus'
import {getCheckupCategoryTreeList} from '@/apis/classInformation'
import {getInvestigationLevelList, getCheckupItemList, editCheckupSubjectInfo, getCheckupItemInSubjectList, getCheckupSubjectDetail, getOrganizationTypeList} from '@/apis/checklistTemp'
import {compareVersion} from "../../../../../utils/compareVersion";

export default {
    name:"edit",
    data(){
        return{
            classlistTree:[],
            classlistTreeProps: {
                label: "checkup_category_name",
                value: "checkup_category_id",
                checkStrictly : true
            },
            headerTitle:"校园安全检查表",
            form:{
                name:"",
                organType:"",
                level:""
            }, // 基础信息
            organOptions:[],// 头部-机构类型
            organId:"",// 机构类型id
            levelId:[],//层级Id
            checkupId:"",// 检查表Id
            levelOptions:[],//头部-考察层级
            entryId:"", // 安全检查条目库--检查条目编号
            keyWord:'',
            type:"",// 安全检查条目库--归属检查分类
            typeOptions:[
                {
                    value:'日常管理',
                    label:"日常管理"
                }
            ], // 安全检查条目库--归属检查分类选项
            entryTableData:[
                // {
                //     id:"",
                //     type:"",
                //     name:"",
                //     content:"",
                //     score:"",
                //     standard:"",
                //     evaluation:"",
                //     material:""
                // }
            ], // 安全检查条目库-表格数据
            multipleEntrySelection:[], // 安全检查条目库-表格多选
            multipleTableSelection:[], // 检查表-表格多选
            checktableData:[
                // {
                //     id:"",
                //     type:"",
                //     name:"",
                //     content:"",
                //     score:"",
                //     standard:"",
                //     evaluation:['书面材料','现场问询','实地考察'],
                //     material:['请实现和牵头单位提供','对校园安全责任制和校园安全事故责任追究制度的宣传',''],
                //     department:""
                // }
            ], // 检查表-表格数据
            dialogVisible:false, // 编辑对话框显示标识
            editForm:{
                department:""
            }, // 编辑对话框-属地部门
            isDisable:true, // "查询"按钮是否显示
            currentObject: {},
            allCheckObj: [],
            waitModifyData:[]
        }
    },
    mounted(){
        //this.$store.commit('setChecklistClass',{isActive:true});
        let currentObject = this.$route.query.currentObject
        console.log('检查表row',currentObject)
        this.getClassListTree()
        this.getOrganTypeList()
        getCheckupItemInSubjectList({
            checkup_subject_id:currentObject
        }).then(res=>{
            this.checktableData = res.data.data.checkup_subject_item_list.sort((f, s) => compareVersion(f.checkup_item_no, s.checkup_item_no))
        })
        getCheckupSubjectDetail({
            checkup_subject_id:currentObject
        }).then(res=>{
            this.currentObject = res.data.data.checkup_subject_info;
            let investigation_level_name_string = ""
            for(let i=0; i<this.currentObject.investigation_level_list.length; i++){
                investigation_level_name_string += this.currentObject.investigation_level_list[i].investigation_level_name
                if(i<this.currentObject.investigation_level_list.length-1){
                    investigation_level_name_string += ','
                }
            }
            this.currentObject.investigation_level_name_string = investigation_level_name_string
            this.currentObject.organization_type_name = this.currentObject.organization_type_info.organization_type_name

            // 获得专题详情
            this.getCheckupDetail(this.currentObject.checkup_subject_id);
            getInvestigationLevelList({
                organization_type_id:this.currentObject.organization_type_info.organization_type_id
            }).then(res=>{
                this.levelOptions = res.data.data.investigation_level_list
            })
        })
    },
    created(){
    },
    methods:{
        cancel(){
            this.$router.back()
        },
        save(){
            let ids = []
            this.form.level.forEach(x=>{
                if(typeof(x) == 'object'){
                    ids.push(x[0])
                } else {
                    ids.push(x)
                }
            })
            let obj = {
                checkup_subject_id:this.currentObject.checkup_subject_id,
                checkup_subject_name:this.currentObject.checkup_subject_name,
                organization_type_id:this.form.organType,
                investigation_level_id_list:ids,
            }
            obj.checkup_item_list = []
             this.checktableData.forEach(x=>{
                obj.checkup_item_list.push({
                    checkup_item_id:x.checkup_item_id,
                    checkup_department_name:x.checkup_department_name
                })
            })
            console.log(obj)
            editCheckupSubjectInfo(obj).then(res=>{
                if(res.data.status == "1"){
                    this.$message.success("保存成功")
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        // 返回上一页
        returnPage(){
            if (window.history.length <= 1) {
                this.$router.push({ path: "/baseData/ChecklistTemp" });
                return false;
            } else {
                this.$router.go(-1);
            }
        },
        // 安全检查条目库-点击多选
        handleEntrySelectionChange(val){
            this.multipleEntrySelection = val;
            console.log('批量增加',this.multipleEntrySelection)
        },
        // 检查表-点击多选
        handleTableSelectionChange(val){
            this.multipleTableSelection = val;

        },
        // 点击检查表表格-“编辑”按钮
        handleEdit(index,row){
            console.log('编辑',row)
            this.dialogVisible = true;
            this.checkupId = row.checkup_item_id
            this.editForm.department = row.checkup_department_name
            this.waitModifyData = [row]

        },
        // 点击“编辑dialog”框中“确定”按钮(与29号接口联动)
        cancelModify(){
            this.dialogVisible = false;
            this.editForm.department = ""
        },
        departmentSubmit(){
            if(this.editForm.department.trim() == ""){
                this.$message.error("请输入属地部门")
                return
            }
            this.dialogVisible = false
            this.waitModifyData.forEach(x=>{
                x.checkup_department_name = this.editForm.department
            })
            this.editForm.department = ""
            this.checktableData = [...this.checktableData]
            /*
            let obj = {
                checkup_subject_id:this.currentObject.checkup_subject_id,
                checkup_subject_name:this.currentObject.checkup_subject_name,
                organization_type_id:this.organId,
                investigation_level_id_list:this.levelId,
                checkup_item_list:[{
                    checkup_item_id:this.checkupId,
                    checkup_department_name:this.editForm.department
                }]
            };
            editCheckupSubjectInfo(obj).then(res => {
                console.log('编辑',res);
                if(res.data.status === "1"){
                    this.dialogVisible = false;
                    this.getCheckObject()
                }
            })
            */
        },
        getClassListTree(){
            getCheckupCategoryTreeList().then((res) => {
                if (res.data.status === "1") {
                    this.classlistTree = res.data.data.checkup_category_tree_list;
                } else {
                    this.$message.error(res.data.msg);
                }
                })
            .catch((error) => {});
        },
        // 点击检查表头部-“编辑”按钮
        handleMultEdit(){
            if(this.multipleTableSelection.length == 0){
                this.$message.error("请选择待修改的数据")
                return
            }
            this.dialogVisible = true;
            this.editForm.department = ""
            this.waitModifyData = [...this.multipleTableSelection]
        },
        // 32-检查表-获得检查表中包含的检查条目列表

        getCheckObject(){
            if(this.entryId == "" && this.type.length == 0 && this.keyWord == ""){
                this.$message.error("请填写查询条件")
                this.allCheckObj = []
                return
            }
            let param = {
                checkup_item_keywords:this.keyWord,
                "checkup_item_no" : this.entryId,
                "checkup_category_id" : this.type[this.type.length-1],
                "pagination" : {
                        "page" : "0",
                        "count" : "10"
                    }
                }
            getCheckupItemList(param).then(res => {
      			console.log('检查条目列表',res);
				 if(res.data.status === '1'){
					 this.allCheckObj = res.data.data.checkup_item_list.sort((f, s) => compareVersion(f.checkup_item_no, s.checkup_item_no))
					 console.log('show data',this.allCheckObj)
				 }
    		})
        },
        // 29-检查专题-获得检查专题详情
        getCheckupDetail(value){
            getCheckupSubjectDetail({
                    checkup_subject_id:value
                }).then(res => {
                console.log('表详情',res);
                let data = res.data.data.checkup_subject_info;
                let listArr = res.data.data.checkup_subject_info.investigation_level_list;
                // let levelId = [];
                listArr.forEach(item => {
                    this.levelId.push(parseInt(item.investigation_level_id))
                })
                this.form.name = data.checkup_subject_name;
                this.form.organType = data.organization_type_info.organization_type_id;
                this.form.level = this.levelId;
                //this.levelOptions = listArr;
                this.organId = data.organization_type_info.organization_type_id;
            })
        },
        // 7-基础-获取机构类型
        getOrganTypeList(){
            // 构造参数
            getOrganizationTypeList().then(res =>{
                console.log('获取机构类型',res.data.data);
                this.organOptions=res.data.data.organization_type_list;
                console.log('organOptions',this.organOptions);
            })
        },
        // 点击“安全检查条目库”中的“添加”按钮
        addCheckTable(index,row){
            console.log('添加',index,row);
            row.checkup_department_name = "";
            if(this.checktableData.findIndex(item => item.checkup_item_id === row.checkup_item_id) === -1 ) {   //不存在添加
                this.checktableData.push(row);
            }
        },
        // 点击“安全检查条目库”中头部的批量“添加”按钮
        addCheckTableMutli(){
            this.multipleEntrySelection.forEach(x=>{
                x.checkup_department_name = ""
                if(this.checktableData.findIndex(item => item.checkup_item_id === x.checkup_item_id) === -1 ) { //不存在添加
                    this.checktableData.push(x);
                }
            })
            // this.checktableData.push(...this.multipleEntrySelection);
        },
        // 点击“检查表”-表格中“删除”按钮
        handleDelete(index,row){
            this.checktableData.splice(index,1);
        },
        // 批量删除
        deleteMutil(){
          //multipleTableList
          this.checktableData.splice(this.$refs.multipleTableList.store.states.selection, 1)
        }
    }
}
</script>
<style scoped>
#edit{
    position: relative;
}
.header {
    width: 100%;
    height: 35px !important;
    border-bottom: 1px solid #ccc;
}
.header-left {
    width: 200px;
    text-align: left;
    position: absolute;
}
.header-title {
    font-weight: bold;
}
.header-right {
    position: absolute;
    right: 20px;
    /* width: 30%; */
    height: 35px;
    top: -15px;
}
.el-form{
    display: flex;
    height: 30px;
}
.el-form-item {
    width: 200px;
    margin-right: 20px;
}
.button {
    height: 38px;
    color: #fff;
    background-color: #000;
}
#edit >>> .el-input__inner {
    height: 35px;
    padding: 0 10px;
    /* border: 1px solid #000; */
     border: 1px solid #92979B;
}
#edit >>> .el-input input::-webkit-input-placeholder{
    color: #9e9fa3;
}
/* 表格样式修改 */
.el-table{
    color: #000;
}
#edit >>> .el-table thead{
    color:#000;
    font-weight: unset;
}
#edit >>> .el-table__header{
    width: 100%;

}
#edit >>> .el-table th.el-table__cell{
    background-color: #f3f3f3;
}
/* #organlist >>> .el-table tr{

} */
#edit >>> .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: unset;
}
.el-button--text{
    color: #000;
    font-size: 13px;
}
.el-table__row>td{
    border: none;
}
.el-table::before{
    height: 0px;
}
#edit >>> .el-checkbox__inner{
    width: 16px;
    height: 16px;
    border: 1px solid #9e9fa3;
}
/* 基础信息样式 */
.el-icon-arrow-left {
    font-weight: bold;
}
.baseInfo {
    text-align: left;
    margin: 0;
    color:#101010;
    font-size:16px;
}

.main-top {
    height: 100px;
    border-bottom: 1px solid #ccc;
}
/* 安全检查条目库样式 ,检查表*/
.main-checkentry,
.main-checktable {
    position: relative;
}
.main-checktable {
    padding-top: 5px;
    box-sizing: border-box;
   border-top: 1px solid #ccc;
}
.checktable-top {
    margin-bottom: 5px;
}
.checkentry-top {
    margin-top: 5px;
}
.checkentry-left,
.checktable-left {
    position: absolute;
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    height: 30px;
    line-height: 30px;
    color:#101010;
}
.checkentry-right,
.checktable-right {
    text-align: right;
}
.checkentry-right .el-input {
    width: 200px;
    height: 35px;
}
#edit >>> .checkentry-right .el-input .el-input__inner {
    height: 30px;
    line-height: 30px;
    font-size: 13px;
}
#edit >>> .checkentry-right .button, .checktable-right .button {
    height: 30px;
    padding-top: 7px;
    background:#0C76FE;
}
/* 对话框样式修改 */
#edit >>> .dialog .el-dialog{
	width: 25%;
}
#edit >>> .dialog .el-dialog__header{
    text-align: left;
}
#edit >>> .dialog .el-dialog__title{
    font-size: 20px;
}
#edit >>> .dialog .el-dialog__body{
    padding: 10px 20px;
    color: #000;
}
#edit >>> .dialog .el-dialog__body .el-form{
    width: 100%;
    height: 100%;
    display: block;
}
#edit >>> .dialog .el-dialog__body .el-form-item {
    width: 90%;
    margin-bottom: 15px;
}
#edit >>> .dialog .el-form-item__label{
    color: #000;
    font-size: 16px;
    text-align: left;
    line-height: 35px;
}
#edit >>> .dialog .el-input__inner {
    border: 1px solid #409eff;
    color: #000;
}

#edit >>> .dialog .el-dialog__footer {
    padding: 0px 20px 20px;
}
.evaluation,
.material
{
    height: 50px;
    overflow: auto;
}

.material:first-child {
    /* top: 12px; */
}


</style>



// WEBPACK FOOTER //
// src/views/backStage/children/ChecklistTemp/edit/edit.vue